import { debounce } from "lodash";
import { useEffect } from "react";
// import tagAttributes2 from "react-testid-generator";

function generaotrTestID(parent) {
  const attrName = "testid";
  function getTestIdByElement(element, index) {
    const dataset = element.dataset;
    // data
    if (dataset[attrName]) {
      return dataset[attrName];
    }
    if (dataset.id) {
      return dataset.id;
    }
    // antd menu-id
    if (dataset.menuId) {
      return dataset.menuId;
    }

    // id
    if (element.id) {
      return element.id;
    }

    // className

    // 某些标签 className 并不是返回字符串
    // const className = element.className;
    const className = element.classList.value;
    if (className) {
      // css modules 会为 className 生成 hash
      let classNameOne = className.split(" ")[0];
      if (classNameOne.includes("__")) {
        classNameOne = classNameOne.split("__")[0];
      }
      return classNameOne;
    }

    const parent = element.parentNode;
    if (parent) {
      const parentTestId = parent.dataset[attrName];
      if (parentTestId) {
        return `${parentTestId}-${element.nodeName}-${index}`;
      }
      return `${parent.nodeName}-${element.nodeName}-${index}`;
    }

    return `${element.nodeName}-${index}`;
  }
  function generator(childrens) {
    childrens.forEach((element, index) => {
      const currentElementTestId = getTestIdByElement(element, index);
      element.setAttribute(`data-${attrName}`, currentElementTestId);
    });
  }

  generator([parent]);
  generator(Array.from(parent.querySelectorAll("*")));
}

const trigger = debounce(() => {
  // tagAttributes2("data-testid", "", 2000, []);
  generaotrTestID(document.querySelector("#root"));
}, 200);

/**
 * 为页面元素添加 testid
 * @param {*} deps
 */
export default function useGeneratorDomTestID(deps) {
  useEffect(() => {
    trigger();
  }, deps);
}
